import {useEffect} from 'react';

import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import amplitudeAutoDeliveryDcxTracking from '@/services/analytics/amplitude/amplitudeAutoDeliveryDcxTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appContent from '@/services/content/appContent.typed';

import useOrderSummaryTracking from '../hooks/useOrderSummaryTracking';

interface StatusPageShellProps {
    analyticsStatus: string;
    Desktop: React.FC;
    Mobile: React.FC;
}

const StatusPageShell = ({analyticsStatus, Desktop, Mobile}: StatusPageShellProps) => {
    const isDesktopLayout = useIsDesktopLayout();
    const {title} = appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};

    useDocumentTitle(title);
    const orderSummaryTrackingValue = useOrderSummaryTracking();

    useEffect(() => {
        amplitudeAutoDeliveryDcxTracking.trackAutoDeliveryDcxOrderScreen(
            analyticsStatus,
            // @ts-expect-error
            orderSummaryTrackingValue
        );
        // @ts-expect-error
        googleAnalyticsService.trackAutoDeliveryOrderScreen(analyticsStatus, orderSummaryTrackingValue);
    }, []);

    return isDesktopLayout ? <Desktop /> : <Mobile />;
};

export default StatusPageShell;
